angular
  .module('capability-ng-global')
  .config(function($httpProvider: ng.IHttpProvider, $httpParamSerializerProvider: ng.IServiceProvider) {
    const paramSerializerWithSemicolons = (params: Record<string, any>) => {
      const paramSerializer = $httpParamSerializerProvider.$get();
      return paramSerializer(params).replace(/;/g, '%3B');
    };
    $httpProvider.defaults.paramSerializer = paramSerializerWithSemicolons;
  });



// WEBPACK FOOTER //
// ./app/lib/global/configuration/param_serialization.ts